import { Card, CardContent } from "@/components/ui/card";
import { CheckSquare, CalendarDays, TrendingUp } from "lucide-react";

export function WhatFlytDoesSection() {
  return (
    <section className="space-y-8">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-display font-bold">
          Små steg hver dag bygger sterke vaner
        </h2>
        <div className="text-muted-foreground space-y-1">
          <p>Flyt er ikke en oppgaveliste.</p>
          <p>Det er et system som bygger selvstendighet – steg for steg.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          {
            icon: CheckSquare,
            title: "Daglige gjøremål",
            desc: "Tydelige oppgaver som fullføres én og én.",
          },
          {
            icon: CalendarDays,
            title: "Aktiviteter",
            desc: "Oversikt over dagen – barnet vet hva som skjer.",
          },
          {
            icon: TrendingUp,
            title: "Fremgang",
            desc: "Synlig progresjon som bygger mestring over tid.",
          },
        ].map((item) => (
          <Card key={item.title} className="text-center">
            <CardContent className="p-6 space-y-3">
              <item.icon className="h-8 w-8 mx-auto text-primary" />
              <h3 className="font-display font-bold">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.desc}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
